import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import useUserData from 'data-hooks/useUserData';
import CustomerDashboardNavLinksUI from './CustomerDashboardNavLinksUI';

const CustomerDashboardNavLinks = ({ items = [] }) => {
  const { pathname } = useLocation();
  const { isTradeUser } = useUserData();

  return (
    <CustomerDashboardNavLinksUI
      items={items}
      currentPath={pathname}
      showQuoteLink={isTradeUser}
    />
  );
};

CustomerDashboardNavLinks.propTypes = {
  items: PropTypes.shape({
    label: PropTypes.string,
    path: PropTypes.string,
  }),
};

export default CustomerDashboardNavLinks;
